var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Controller, useWatch } from 'react-hook-form';
var MobilePermissions = function (_a) {
    var permissionGroups = _a.permissionGroups, control = _a.control, translate = _a.translate, setValue = _a.setValue;
    var theme = useTheme();
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and orientation:landscape');
    var isIpadMini = useMediaQuery('(min-width: 768px) and (max-width: 768px)');
    var formPermissionGroups = useWatch({
        control: control,
        name: 'permissionGroups'
    }) || [];
    var getPermissionDisabled = function (groupIndex, permissionIndex) {
        var group = formPermissionGroups[groupIndex];
        if (!group || !group.permissions)
            return false;
        for (var i = permissionIndex + 1; i < group.permissions.length; i++) {
            if (group.permissions[i].permissionName && group.permissions[i].isAssigned) {
                return true;
            }
        }
        return false;
    };
    var onPermissionChanged = function (groupIndex, permissionIndex, isAssigned) {
        var currentPermissions = __spreadArray([], __read(formPermissionGroups[groupIndex].permissions), false);
        if (isAssigned) {
            for (var i = 0; i <= permissionIndex; i++) {
                setValue("permissionGroups.".concat(groupIndex, ".permissions.").concat(i, ".isAssigned"), true);
            }
        }
        else {
            for (var i = permissionIndex; i < currentPermissions.length; i++) {
                setValue("permissionGroups.".concat(groupIndex, ".permissions.").concat(i, ".isAssigned"), false);
            }
        }
    };
    return (_jsx(Box, { sx: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 1,
            overflowY: 'auto',
            maxHeight: isscreen600900Landscape
                ? 'calc(100svh - 220px)'
                : isIpadMini
                    ? 'calc(100svh - 471px)'
                    : 'calc(100svh - 442px)'
        }, children: _jsx(Grid, { container: true, spacing: 2, children: formPermissionGroups === null || formPermissionGroups === void 0 ? void 0 : formPermissionGroups.map(function (group, groupIndex) {
                var _a, _b, _c;
                return (_jsx(Grid, { size: { xs: 12 }, children: _jsx(Box, { sx: {
                            p: '8px 12px 16px 12px',
                            boxShadow: theme.customShadows.z8,
                            border: "2px solid ".concat(theme.palette.background.paper),
                            borderRadius: theme.spacing(2),
                            backgroundColor: theme.palette.background.paper,
                            transition: 'border-color 0.3s ease'
                        }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Box, { children: _jsx(Typography, { variant: 'body1', children: translate("common.".concat((_b = (_a = group.groupName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : 'unknown')) }) }), _jsx(Grid, { container: true, spacing: 1, children: (_c = group.permissions) === null || _c === void 0 ? void 0 : _c.map(function (permission, permissionIndex) {
                                        var _a, _b, _c, _d;
                                        return (_jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    borderRadius: 1
                                                }, children: [_jsx(Typography, { variant: 'body2', sx: {
                                                            color: !permission.permissionName ||
                                                                getPermissionDisabled(groupIndex, permissionIndex)
                                                                ? theme.palette.text.disabled
                                                                : theme.palette.text.primary
                                                        }, children: translate("roles.".concat((_d = (_c = (_b = (_a = permission.permissionName) === null || _a === void 0 ? void 0 : _a.split('.')) === null || _b === void 0 ? void 0 : _b.pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : 'read')) }), _jsx(Controller, { control: control, name: "permissionGroups.".concat(groupIndex, ".permissions.").concat(permissionIndex, ".isAssigned"), render: function (_a) {
                                                            var field = _a.field;
                                                            return (_jsx(Switch, { size: 'small', checked: field.value, disabled: !permission.permissionName ||
                                                                    getPermissionDisabled(groupIndex, permissionIndex), onChange: function (e) {
                                                                    field.onChange(e.target.checked);
                                                                    onPermissionChanged(groupIndex, permissionIndex, e.target.checked);
                                                                } }));
                                                        } })] }) }, permissionIndex));
                                    }) })] }) }) }, groupIndex));
            }) }) }));
};
export default MobilePermissions;
